// utils/api.js
import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_USERS_BACKEND_URL}/api`, // change this to your base URL
  withCredentials: true, // if using cookies/session
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to include token on every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
